import Vue from 'vue'
import axios from 'axios';
import VueAxios from 'vue-axios';
import { Button, CheckboxGroup, CheckboxButton, Checkbox, RadioGroup, RadioButton, Radio } from 'element-ui';
import App from './App.vue'
import router from './router'
import store from './store'
import vueTouch from 'vue-touch'
import FridayAgent from '@cvte/fridayagent3'
import './components';
import '@assets/scss/_vant_reset.scss';

var APP_ID = {
  DEV: '16f2263be93156aad0ff6ef2d4d31cda',
  TEST: '938cf88dd72c83a3eb6cea41bfcbbc76',
  PROD: '15b9d44f8bd15cbe13cc68c554f625ca',
  CLUE: '213b50b5-1eab-42bd-8482-725e26bd8d84',
};

var SERVER_URL = {
  DEV: ['http://localhost:8080'],
  PROD: ['res.maxhub.com', 'res.maxhub.vip']
};

var appId = '';
var url = window.location.href;

if (SERVER_URL['DEV'].find(element => url.match(element))) {
  appId = APP_ID['DEV'];
} else if(SERVER_URL['PROD'].find(element => url.match(element))) {
  appId = APP_ID['PROD'];
}

Vue.component(Button.name, Button);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(CheckboxButton.name, CheckboxButton);
Vue.component(Checkbox.name, Checkbox);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Radio.name, Radio);
Vue.use(VueAxios, axios);
Vue.use(vueTouch, {name: 'v-touch'})
Vue.use(FridayAgent, appId);

Vue.config.productionTip = false
Vue.store = store;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
